import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Tag from '../../ui/Tag';
import Link from '../../ui/Link';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import {AperzaLinkUtil, ImageUrlUtil} from '@aperza/util';
import useReactiveMessage from '../../hook/UseReactiveMessage';
import useYouTubeInfo from "../../hook/UseYouTubeInfo";

import style from './CatalogCard.module.scss';

const CatalogCard = (props) => {

  let {
    title,
    subtitle,
    description,
    catalogImageUrl,
    catalogPageUrl,
    catalogVideoId,
    catalogPreviewImageUrls = [],
    companyName,
    companyLogoUrl,
    companyPageUrl,
    companyContractDisplayId,
    companyId,
    catalogId,
    fileSize,
    tags = [],
    disablePreview = false,
    columns,
    columnsSp
  } = props;

  // console.log('CATALOG CARD ++++', props);

  const {t, i18n} = useTranslation('catalog');
  const {sendMessage} = useReactiveMessage('CATALOG_PREVIEW');

  let {
    video,
    setVideoId,
  } = useYouTubeInfo(catalogVideoId);

  useEffect(() => {
    setVideoId(catalogVideoId);
  }, [catalogVideoId]);

  const getColClass = () => {
    let col_class;
    switch(parseInt(columns)) {
      case 1:
        col_class = 'col-md-12';
        break;
      case 2:
        col_class = 'col-md-6';
        break;
      case 3:
        col_class = 'col-md-4';
        break;
      case 4:
        col_class = 'col-md-3';
        break;
      case 5:
        col_class = 'col-md-2-5';
        break;
      case 6:
        col_class = 'col-md-2';
        break;
      default:
        col_class = 'col-md';
        break;
    }
    switch(parseInt(columnsSp)) {
      case 1:
        col_class += ' col-sm-12 col-12';
        break;
      case 2:
        col_class += ' col-sm-6 col-6';
        break;
      case 3:
        col_class += ' col-sm-4 col-4';
        break;
      case 4:
        col_class += ' col-sm-3 col-3';
        break;
      case 5:
        col_class += ' col-sm-2-5 col-2-5';
        break;
      case 6:
        col_class += ' col-sm-2 col-2';
        break;
      default:
        col_class += ' col-sm col';
        break;
    }
    return col_class;
  };

  const onClickPreview = () => {
    if (disablePreview) return;
    sendMessage({
      title,
      subtitle,
      description,
      tags,
      catalogPreviewImageUrls,
      catalogPageUrl,
      companyName,
      companyLogoUrl,
      companyPageUrl,
      companyContractDisplayId,
      companyId,
      catalogId,
      fileSize,
    }, 'CATALOG_PREVIEW');
  };

  const onClickDownload = () => {
    sendMessage({
      companyContractDisplayId,
      companyId,
      catalogId,
    }, 'CATALOG_DOWNLOAD_CLUEZ');
  };

  const onClickVideo = () => {
    sendMessage(video, 'CATALOG_VIDEO');
  };

  const createCatalogPageUrl = () => {
    return AperzaLinkUtil.createCatalogPageUrl({companyContractDisplayId, catalogId, lang:i18n.language});
  };

  return (
    <li className={clsx('product-item flex-column align-items-stretch',getColClass())}>
      <div className={clsx('img',style.CatalogCardImage)} data-mh="mh_01">
        {disablePreview==true &&
        <Link className={style.CatalogCardImageLink} type={'link'} url={catalogPageUrl}>
          <img className="m_imgShadow" src={ImageUrlUtil.resize(catalogImageUrl, undefined, 260)} />
        </Link>
        }
        {disablePreview==false &&
        <React.Fragment>
          <a onClick={onClickPreview} className={clsx('catalogPreview',style.CatalogCardImageLink)}>
            <img className="m_imgShadow" src={ImageUrlUtil.resize(catalogImageUrl, undefined, 260)} />
          </a>
          <div className="m_previewBtn">
            <a onClick={onClickPreview} >{t('preview')}</a>
          </div>
        </React.Fragment>
        }
      </div>
      <div className="dtl" data-mh="mh_02">
        <p className="ttl">
          <a target="_blank" className={clsx('catalogTitleLink',style.CatalogCardTitleLink)} href={catalogPageUrl}>{title}</a>
        </p>
        <p className={style.CatalogCardCompanyLink}><a target="_blank" href={companyPageUrl}>{companyName}</a></p>
        {tags.map((tag, index) => <Tag key={index} name={tag}/>)}
      </div>
      <div className="btnWrap mt-auto" data-mh="mh_03">
        { !disablePreview && catalogVideoId != null && catalogVideoId !== undefined &&
        <a className="btn btn-default btn-block btn-lg mb-2 js_modal modal-youtube td-click"
           onClick={onClickVideo}
           data-youtube={catalogVideoId}
        >
          <i className="fa fa-video-camera"></i> 動画を見る
        </a>
        }
        { !disablePreview &&
        <a href="#" className="btn btn-primary btn-block btn-lg text-wrap" onClick={onClickDownload}
           data-company_id={companyId} data-catalog_id={catalogId}>
          <i className="fa fa-download fa-fw"></i>{t('download')}
        </a>
        }
        { disablePreview &&
          <Link type={'button'}
                url={catalogPageUrl}
                className={clsx('btn-block',style.CatalogCardViewPageBtn)} variant="default" size="lg">
            {t('catalog.recommend.page')}
          </Link>
        }
      </div>
    </li>
  );
};

CatalogCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  catalogImageUrl: PropTypes.string,
  catalogPageUrl: PropTypes.string,
  catalogPreviewImageUrls: PropTypes.arrayOf(PropTypes.string),
  companyName: PropTypes.string,
  companyLogoUrl: PropTypes.string,
  companyPageUrl: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  disablePreview: PropTypes.bool,
  columns: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  columnsSp: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};

export default CatalogCard;

